import React, { useEffect, useContext, useState} from 'react'
import { appContext } from "./../AppContext";
import {useFetch} from './../utils/hooks/useFetch'
import Character from '../components/character/player/Character'
import { Result, Spin } from 'antd';

export default function CharacterPage() {

    const [appState, AppDispatch] = useContext(appContext);
    const [doFetch] = useFetch();

    const [characterTypes, setCharacterTypes] = useState([]);
    const [characterStatusses, setCharacterStatusses] = useState([]);
    const [races, setRaces] = useState([]);
    const [originalCharacter, setOriginalCharacter] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    //const characterId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1)

    const urlParams = new URLSearchParams(window.location.search);
    const characterId = urlParams.get('id'); 

    useEffect(() => {
        doFetch("/api/skillPoint/GetAll")
            .then((response) => skillPointTypesLoaded(response.isSuccess, response.result))

        function skillPointTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            AppDispatch({ type: "SETSKILLPOINTTYPES", payload: result })
          }
        }

        doFetch("/api/skillPoint/GetAllStatTypes")
            .then((response) => statTypesLoaded(response.isSuccess, response.result))

        function statTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            AppDispatch({ type: "SETSTATTYPES", payload: result })
          }
        }

        doFetch("/api/character/GetCharacterTypes")
            .then((response) => characterTypesLoaded(response.isSuccess, response.result))

        function characterTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            setCharacterTypes(result)
          }
        }

        doFetch("/api/character/GetCharacterStatusses")
            .then((response) => characterStatussesLoaded(response.isSuccess, response.result))

        function characterStatussesLoaded(isSuccess, result) {
          if(isSuccess) {
            setCharacterStatusses(result)
          }
        }

        doFetch(`/api/race/${appState.storyId}/GetWiki`)
            .then((response) => racesLoaded(response.isSuccess, response.result))

        function racesLoaded(isSuccess, result) {
            if(isSuccess) {
                setRaces(result)
            }
        }

        AppDispatch({ type: "SETSELECTEDPAGE", payload: "Character" })
    },     //eslint-disable-next-line
    [])

    useEffect(() => {
        refresh()
    }, // eslint-disable-next-line
    [appState.storyId])

    function refresh() {
        doFetch(`/api/character/${characterId}`)
            .then((response) => characterLoaded(response.isSuccess, response.result))

        function characterLoaded(isSuccess, result) {
          setIsLoading(false);
          if(isSuccess) {
            setOriginalCharacter(result);
            return;
          }

          setOriginalCharacter(null)
        }
    }

    if(isLoading) {
        return <Spin />
    }

    if(originalCharacter === null) {
        return (            
            <Result
                status={"error"}
                title="Character not found"
            />
        )

    }

    return (
        <>
            <br />
            <Character 
                refresh={refresh}
                characterTypes={characterTypes}
                characterStatusses={characterStatusses}
                races={races}
                originalCharacter={originalCharacter}
            />
        </>
    )
}